import { render, staticRenderFns } from "./OrdersInvoice.vue?vue&type=template&id=d056be0e&scoped=true"
import script from "./OrdersInvoice.vue?vue&type=script&lang=js"
export * from "./OrdersInvoice.vue?vue&type=script&lang=js"
import style0 from "./OrdersInvoice.vue?vue&type=style&index=0&id=d056be0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d056be0e",
  null
  
)

export default component.exports